var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.2812C19.5912 23.2812 24.125 19.1255 24.125 14C24.125 8.8745 19.5912 4.71875 14 4.71875C8.40875 4.71875 3.875 8.8745 3.875 14C3.875 16.367 4.84137 18.5259 6.43212 20.165C6.91812 20.6679 7.26463 21.335 7.09138 22.0111C6.90167 22.7505 6.54662 23.4371 6.053 24.0193C6.44804 24.0902 6.84864 24.1256 7.25 24.125C8.69225 24.125 10.0287 23.6728 11.1256 22.9021C12.0369 23.1496 13.0021 23.2812 14 23.2812Z",
    stroke: "#3ADEA2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2ef4986c35e36b06c65c7f00c280fc23.svg";
export { ForwardRef as ReactComponent };